module.exports = true;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/_library.js
// module id = 321
// module chunks = 0